/* Delfino — pagina de produs (Task 16).

   Port al JS-ului inline de pe live (source/live-supl/dom/matrix/_inline-*.js) și al exportului
   (source/export/02-matrix-colagen/01-product-gallery/section.js + 02-product-info/section.js):
   galerie + lightbox, pachete de cantitate, stepper de cantitate, WhatsApp, contoarele din
   „ce observă clienții” și săgețile programului de 90 de zile.

   Ce s-a schimbat față de live:
   - nimic nu mai atârnă de funcții globale (nextSlide/updateQty/openLightbox) și de id-uri unice:
     totul e legat de rădăcina secțiunii, [data-dl-product], deci merg mai multe instanțe;
   - lightbox-ul și modalul etichetei sunt <dialog> (Escape și focus trap native);
   - nu se mai apelează niciun endpoint intern (/api/cart-add): formularul e cel standard Shopify,
     preluat de Releasit sau de DL.bindAtcForms din theme.js;
   - totalurile pachetelor se recalculează în JS cu exact aceeași aritmetică ca în Liquid
     (bundleTotals), ca schimbarea variantei să nu strice prețurile randate pe server;
   - fiecare ascultător e strâns la shopify:section:unload (editorul de teme aruncă nodul vechi);
   - Task 32/35 (A3): dacă aplicația Releasit COD e pe modul „formular în pagină", formularul ei
     injectat în hero e MUTAT în slotul de la finalul paginii (secțiunea product-cod-slot) — vezi
     blocul „Releasit COD embedded" de mai jos. Cât timp formularul embedded e în pagină, butonul
     „Adaugă în coș" al temei NU se afișează (Task 35): aplicația GOLEȘTE coșul Shopify la fiecare
     încărcare a paginii de produs și îl re-populează din câmpul temei `[name="quantity"]`; dacă
     butonul temei ar mai trimite și el `/cart/add`, ar dubla cantitatea deja pusă de aplicație (și
     ar goli orice alt produs din coș la pagina următoare). În hero intră în schimb un buton
     „Comandă acum" (`[data-dl-hero-order]`, în blocul add_to_cart din main-product.liquid), pe
     care aplicația îl preia prin clasele ei GemPages — merge în ambele moduri: embedded (rezerva
     de-aici derulează la formular) și popup, de la lansare (aplicația îl înlocuiește și deschide
     popup-ul). Secțiunea-slot rămâne montată în template și în modul „popup": acolo niciun nod al
     aplicației nu trece filtrul de relocare (popup-ul e overlay), deci nu se mută nimic. Fără slot
     în pagină, relocarea nu pornește deloc.

   Globala expusă: DLProduct (ajutoarele pure merg și în Node, fără window/document; în browser
   primește în plus findEmbeddedCod/relocateEmbeddedCod/bindOrderButtons, expuse pentru teste). */
(function (root) {
  'use strict';

  /* ===== Ajutoare pure (testate în test/unit/bundles.test.mjs) ===== */

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  /* Totalurile unei trepte de pachet, în bani.
     total = preț × cantitate − floor(preț × cantitate × reducere / 100), exact ca formularul Releasit
     și ca Liquid-ul din main-product; was = prețul barat (sau prețul întreg) × cantitate. */
  function bundleTotals(priceCents, compareCents, qty, discountPct, amountOffCents) {
    var price = Math.max(0, toInt(priceCents, 0));
    var quantity = Math.max(1, toInt(qty, 1));
    var discount = Math.min(100, Math.max(0, toInt(discountPct, 0)));
    var compare = Math.max(price, toInt(compareCents, 0));
    /* Ca Releasit: reducerea (în bani) se rotunjește în JOS și se scade din total — altfel pagina
       arăta cu 1 ban mai puțin decât formularul (ex. 2 × 79,99 −10 % = 143,99, nu 143,98). */
    var full = price * quantity;
    var total = full - Math.floor((full * discount) / 100);
    /* Reducere fixă în bani (oferte Releasit „fixed”), scăzută după procent, niciodată sub 0. */
    total = Math.max(0, total - Math.max(0, toInt(amountOffCents, 0)));
    return { total: total, was: compare * quantity, perUnit: Math.round(total / quantity) };
  }

  /* Următoarea cantitate permisă: urcă/coboară pe treptele existente, iar peste ultima treaptă
     pasul devine liber (± 1). Nu coboară niciodată sub 1. */
  function nextAllowedQty(current, dir, tiers) {
    var list = (tiers || [])
      .map(function (t) { return toInt(t, 0); })
      .filter(function (t) { return t > 0; })
      .sort(function (a, b) { return a - b; });
    var cur = Math.max(1, toInt(current, 1));
    var up = toInt(dir, 1) > 0;
    if (!list.length) return up ? cur + 1 : Math.max(1, cur - 1);
    if (up) {
      for (var i = 0; i < list.length; i++) if (list[i] > cur) return list[i];
      return cur + 1;
    }
    if (cur > list[list.length - 1]) return cur - 1;
    for (var j = list.length - 1; j >= 0; j--) if (list[j] < cur) return list[j];
    return 1;
  }

  /* Varianta potrivită combinației alese de client.
     `values` e lista valorilor selectate, pe indexul opțiunii (o poziție poate lipsi: la stilul
     „butoane", o opțiune fără buton bifat lasă o gaură în listă, iar Array#every sare peste găuri).
     Reguli:
       • dintre variantele care se potrivesc, o preferăm pe una DISPONIBILĂ — varianta veche lua
         orbește `filter(...)[0]`, deci o combinație parțială putea ateriza pe una epuizată;
       • dacă toate potrivirile sunt epuizate, întoarcem totuși prima, ca pagina să se repicteze
         și butonul să spună „Stoc epuizat";
       • dacă nu se potrivește NICIUNA (combinație inexistentă în Shopify), întoarcem
         `{ variant: null, available: false }` — apelantul marchează epuizat în loc să nu facă nimic
         (comportamentul vechi: applyVariant(undefined) ieșea tăcut și pagina rămânea pe varianta
         precedentă, adică selectorul părea stricat). */
  function pickVariant(variants, values) {
    var list = variants || [];
    var vals = values || [];
    var matches = list.filter(function (v) {
      return vals.every(function (val, i) { return !val || (v.options || [])[i] === val; });
    });
    for (var i = 0; i < matches.length; i++) {
      if (matches[i].available !== false) return { variant: matches[i], available: true };
    }
    return { variant: matches[0] || null, available: false };
  }

  root.DLProduct = root.DLProduct || {};
  root.DLProduct.bundleTotals = bundleTotals;
  root.DLProduct.nextAllowedQty = nextAllowedQty;
  root.DLProduct.pickVariant = pickVariant;

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ===== Partea de DOM ===== */

  var DL = (window.DL = window.DL || {});
  /* Niciun text în română nu mai stă aici: șirurile vin din theme/locales/*.json, injectate în
     `window.DLSettings.t` de layout/theme.liquid (`atcBundle` = products.add_count_to_cart,
     `wa` = products.whatsapp_message). Locurile lor („{{ count }}", „{{ quantity }}", …) sunt
     completate de fill(). t() întoarce '' dacă șirul lipsește, iar apelanții tratează cazul. */
  function t(key) {
    var s = window.DLSettings && window.DLSettings.t && window.DLSettings.t[key];
    return typeof s === 'string' ? s : '';
  }

  function fill(template, values) {
    return Object.keys(values).reduce(function (s, k) {
      return s.replace(new RegExp('{{\\s*' + k + '\\s*}}', 'g'), values[k]);
    }, template);
  }

  function money(cents) {
    if (DL && typeof DL.money === 'function') return DL.money(cents);
    return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ===== Releasit COD embedded → slotul de la finalul paginii (Task 32/35 / A3) =====

     Ce face aplicația azi (mod „embedded", măsurat pe draft cu aplicația live, 17.09.2026):
     injectează un container cu `id="rsi-cod-form-product-cache"` imediat după formularul temei,
     în hero, și ascunde butonul `[data-dl-atc]` al temei (display:none calculat) — pentru că ea
     GOLEȘTE coșul Shopify la fiecare încărcare a paginii de produs și îl re-populează din
     `[name="quantity"]`; dacă butonul temei ar mai adăuga și el în coș, ar dubla cantitatea
     (Task 35, reprodus de Robert pe draft, 18.09.2026). Cererea lui Robert: formularul coboară la
     finalul paginii (secțiunea product-cod-slot); butonul temei RĂMÂNE ascuns (secțiunea hero
     primește clasa `dl-cod-embedded`, cu o plasă de siguranță în CSS), iar stepperul, „Comandă
     telefonic" și „Comandă pe WhatsApp" rămân vizibile — plus un buton nou, „Comandă acum"
     (`[data-dl-hero-order]`), pe care aplicația îl preia când trece pe modul „popup".

     Ce trebuie să se întâmple la lansare (mod „popup"): NIMIC. Secțiunea-slot rămâne montată în
     template (Robert nu trebuie să umble prin editor), deci codul ăsta rulează pe orice pagină de
     produs — de-asta filtrul de mai jos e strict: în modul popup NICIUN nod al aplicației nu-l
     trece, deci nu se mută nimic și secțiunea rămâne invizibilă (CSS: fără `is-filled`).

     Selectorii aplicației nu sunt documentați public (id-ul `rsi-cod-form-product-cache` e
     singurul MĂSURAT, pe draft, 17.09.2026), deci nu ne bazăm pe ei: un candidat e „formularul
     embedded" doar dacă trece TOATE testele din findEmbeddedCod() — are controale reale de
     formular, are o cutie randată de cel puțin 80px, nu e overlay (el sau părintele lui direct cu
     position fixed/absolute = popup), nu e buton/link (butoanele noastre product-cta poartă chiar
     clasele Releasit `_rsi-cod-form-gempages-button-overwrite`, care se potrivesc pe substring cu
     `[class*="rsi-cod-form"]`), nu e în secțiunile product-cta și nu e deja în slot.

     Aceeași listă de selectori mai apare în DOUĂ locuri, cu alt scop — dacă o schimbi aici,
     uită-te și acolo:
       · theme/assets/section-product-cta.js — butoanele „Comandă acum" caută formularul (oriunde
         ar fi, inclusiv în slotul nostru) ca să deruleze la el, plus popup-ul, ca să se retragă;
       · theme/assets/theme.js, DL.bindAtcForms — bail-out-ul care lasă formularul temei pe seama
         aplicației. Acolo id-ul `rsi-cod-form-product-cache` NU e inclus INTENȚIONAT: butonul
         temei rămâne ascuns cât timp formularul e embedded (Task 35), dar `#product-form-main`
         trebuie să rămână pe AJAX + sertar — rezerva din hero (`[data-dl-hero-order]`, mai jos)
         îl trimite prin `requestSubmit()` când nu găsește niciun formular Releasit vizibil, iar
         el nu trebuie predat aplicației, care are deja propriul formular în slot. */
  var COD_SELECTOR = '#rsi-cod-form-product-cache, #rsi-cod-form, [id^="rsi-cod"], [class*="rsi-cod-form"]';
  var COD_WATCH_MS = 8000;   // cât urmărim injectarea (Releasit vine asincron, după încărcare)
  var COD_MAX_MOVES = 2;     // mutarea inițială + o singură repetare, dacă re-injectează în hero
  var COD_MIN_HEIGHT = 80;   // sub atât nu e un formular de comandă, ci un wrapper tehnic

  /* „Ascuns" = fără cutie de layout (display:none pe el sau pe un părinte) ori visibility:hidden —
     același criteriu ca în section-product-cta.js / section-product-sticky-bar.js. */
  function isHidden(el) {
    if (!el) return true;
    if (el.offsetParent === null) return true;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    return !!cs && (cs.display === 'none' || cs.visibility === 'hidden');
  }

  function codSlot() {
    return document.querySelector('[data-dl-cod-slot]');
  }

  /* Overlay = popup: formularul embedded curge în pagină (static/relative), popup-ul aplicației e
     scos din flux. Verificăm nodul ȘI toți strămoșii lui până la <body>, fiindcă aplicația își
     poate pune formularul cu două-trei niveluri sub fundalul poziționat al popup-ului. */
  function isOverlay(el) {
    if (!el || !window.getComputedStyle) return false;
    var cs = window.getComputedStyle(el);
    return !!cs && (cs.position === 'fixed' || cs.position === 'absolute');
  }
  function insideOverlay(el) {
    for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      if (isOverlay(n)) return true;
    }
    return false;
  }

  function findEmbeddedCod(slot) {
    var nodes = document.querySelectorAll(COD_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.tagName === 'BUTTON' || el.tagName === 'A') continue;
      if (el.closest && el.closest('[data-dl-cta], .pp-cta, [data-dl-cod-slot]')) continue;
      if (slot.contains(el)) continue;
      if (isHidden(el)) continue;
      // Un formular de comandă are ÎNTOTDEAUNA câmpuri; o carcasă de popup sau un nod-cache gol nu.
      if (!el.querySelector || !el.querySelector('input, select, textarea')) continue;
      // …și ocupă loc pe ecran: sub 80px e un wrapper tehnic, nu formularul.
      var rect = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
      if (!rect || rect.height < COD_MIN_HEIGHT) continue;
      if (insideOverlay(el)) continue;
      return el; // querySelectorAll întoarce în ordinea documentului → containerul exterior primul
    }
    return null;
  }

  function relocateEmbeddedCod(section) {
    var slot = codSlot();
    if (!slot) return false;
    var form = findEmbeddedCod(slot);
    if (!form) {
      // Re-randare din editor (shopify:section:load pe hero): formularul a fost mutat deja în slot,
      // deci nu mai e nimic de mutat, dar hero-ul cel nou trebuie să primească tot marcajul.
      // Același lucru când Releasit pune formularul DIRECT în slot, prin cârligul lui oficial
      // (`#_rsi-cod-form-embed-custom-hook`, 23.09.2026): nimic de mutat, dar secțiunea trebuie arătată.
      if (slot.querySelector && slot.querySelector('._rsi-cod-form-embed-container, #_rsi-cod-form-modal-form, form')) {
        var filledHost = slot.closest ? slot.closest('[data-dl-cod-section]') : null;
        if (filledHost) filledHost.classList.add('is-filled');
        if (section && section.classList) section.classList.add('dl-cod-embedded');
      }
      return false;
    }
    slot.appendChild(form); // ACELAȘI nod, nu o copie: ascultătorii puși de Releasit rămân legați
    var host = slot.closest ? slot.closest('[data-dl-cod-section]') : null;
    if (host) host.classList.add('is-filled'); // secțiunea e display:none până acum (vezi CSS)
    // Butonul temei NU se readuce (Task 35): rămâne exact cum l-a lăsat aplicația (ascuns) —
    // clasa de mai jos e doar un marcaj, plasa de siguranță reală e regula CSS scoped pe ea
    // (section-product-cod-slot.css), care ascunde [data-dl-atc] cât timp secțiunea are clasa.
    if (section && section.classList) section.classList.add('dl-cod-embedded');
    return true;
  }

  function watchEmbeddedCod(section, teardown) {
    // Comutator de diagnostic (22.09.2026): cu `?rsi=inplace` în adresă formularul Releasit NU mai e mutat în
    // slotul de jos — rămâne unde îl pune aplicația. Așa se vede dacă mutarea e cauza încărcării la nesfârșit.
    try { if (/[?&]rsi=inplace(&|$)/.test(window.location.search)) return; } catch (e) { /* fără location: mergem mai departe */ }
    if (!codSlot() || typeof MutationObserver !== 'function') return;
    // Clasa pusă la relocare e a secțiunii, nu a formularului mutat — scoasă la destroy/teardown
    // (editorul de teme aruncă nodul vechi), ca o secțiune nouă să pornească din nou neutră.
    teardown.push(function () { if (section && section.classList) section.classList.remove('dl-cod-embedded'); });
    var moves = relocateEmbeddedCod(section) ? 1 : 0;
    if (moves >= COD_MAX_MOVES) return;
    var observer = null;
    var timer = 0;
    function stop() {
      if (observer) { observer.disconnect(); observer = null; }
      if (timer) { clearTimeout(timer); timer = 0; }
    }
    observer = new MutationObserver(function () {
      if (!relocateEmbeddedCod(section)) return; // propria noastră mutare trece pe-aici: no-op
      moves++;
      if (moves >= COD_MAX_MOVES) stop();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    timer = setTimeout(stop, COD_WATCH_MS);
    teardown.push(stop);
    if (DL && typeof DL.onDestroy === 'function') DL.onDestroy(section, stop);
  }

  /* Formularul de comandă vizibil AL APLICAȚIEI, indiferent unde ar fi — folosit DOAR de rezerva
     butoanelor de comandă (bindOrderButtons, mai jos), ca să decidă unde derulează click-ul.
     Selectorii sunt ALȚII decât COD_SELECTOR (măsurați separat, 18.09.2026): acolo relocarea chiar
     mută nodul, deci filtrele sunt stricte; aici doar verificăm dacă există o țintă vizibilă. */
  var HERO_ORDER_FORM_SELECTOR = '._rsi-cod-form-embed-container, #_rsi-cod-form-modal-form';
  function visibleHeroOrderForm() {
    var nodes = document.querySelectorAll(HERO_ORDER_FORM_SELECTOR);
    for (var i = 0; i < nodes.length; i++) if (!isHidden(nodes[i])) return nodes[i];
    return null;
  }

  /* Task 42: rezerva butonului „Comandă acum" — inițial doar cel din hero (main-product.liquid,
     blocul add_to_cart, `[data-dl-hero-order]`), acum generalizată la ORICE buton de comandă din
     pagină, inclusiv cele repetate sub cele 4 secțiuni marcate de Robert (`[data-dl-order-btn]`,
     theme/snippets/order-button.liquid). În modul „popup" al aplicației Releasit, ea îi înlocuiește
     NODUL cu al ei (clasele `_rsi-cod-form-*` de pe el sunt cârligul GemPages) — ascultătorul de-aici
     pleacă odată cu nodul vechi, deci rezerva de mai jos rulează DOAR cât timp butonul e încă al
     temei: fără aplicație (randare izolată, preview) sau în modul „embedded", înainte ca ea să apuce
     să-l înlocuiască. Legarea e document-wide (nu scoped la secțiunea [data-dl-product]), fiindcă
     butoanele repetate trăiesc în alte secțiuni (product-video-duo, product-benefits-image,
     product-transformation, product-video-testimonials). */
  var ORDER_BTN_SELECTOR = '[data-dl-hero-order], [data-dl-order-btn]';
  function bindOrderButtons(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var btns = scope.querySelectorAll(ORDER_BTN_SELECTOR);
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (!btn || btn.dataset.bound) continue;
      btn.dataset.bound = '1';
      (function (btn) {
        function onClick() {
          var form = visibleHeroOrderForm();
          if (form) {
            form.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'auto' : 'smooth' });
            var firstField = form.querySelector('input:not([type=hidden]), select, textarea');
            if (firstField && typeof firstField.focus === 'function') firstField.focus();
            return;
          }
          // Fără formular Releasit vizibil: se comportă ca „Adaugă în coș" — DL.bindAtcForms
          // (theme.js) interceptează submit-ul formularului temei și face AJAX + sertar.
          var mainForm = document.querySelector('#product-form-main');
          if (!mainForm) return;
          if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
          else mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
        btn.addEventListener('click', onClick);
        function cleanup() { btn.removeEventListener('click', onClick); delete btn.dataset.bound; }
        if (DL && typeof DL.onDestroy === 'function') DL.onDestroy(btn, cleanup);
      })(btn);
    }
  }

  /* ===== Modalul etichetei (Task 37) =====

     [data-dl-label-open] e butonul de sub galerie (main-product.liquid, secțiunea Produs) — cel
     mai des scoped chiar în secțiunea `section` primită de bindSection. Ce deschide diferă:
       · [data-dl-label-modal] — dialogul cu IMAGINEA etichetei (Task 16), tot în `section`, dacă
         `label_image` e setată;
       · altfel, primul [data-dl-label-dialog] DIN DOCUMENT — secțiunea nouă „Eticheta produsului"
         (product-label.liquid), care NU e copil al [data-dl-product]: trăiește separat în pagină,
         de-asta căutarea ei e mereu document.querySelector, nu $(...) scoped la `section`.
     La init, dacă butonul e randat ascuns (fără `label_image`, vezi main-product.liquid) și există
     un [data-dl-label-dialog] pe pagină, îl arătăm — altfel n-are ce să deschidă, rămâne ascuns.
     Butoanele [data-dl-label-close] și clicul pe fundal (dialogul însuși, în afara panoului) închid
     oricare dintre cele două dialoguri — de-asta bucla de mai jos e document-wide, nu scoped:
     dialogul nou nu e văzut deloc de un `$(...)` legat de `section`.
     Extrasă ca funcție numită (nu inline în bindSection) și expusă pe DLProduct DOAR pentru teste
     (test/unit/product-label.test.mjs), la fel ca bindOrderButtons mai sus — nimic din temă n-o cheamă
     altundeva, iar expunerea nu schimbă comportamentul. */
  function bindLabelDialog(section) {
    var openBtn = section && section.querySelector('[data-dl-label-open]');
    if (openBtn && !openBtn.dataset.bound) {
      openBtn.dataset.bound = '1';
      if (openBtn.hidden && document.querySelector('[data-dl-label-dialog]')) openBtn.hidden = false;
      var onOpen = function (e) {
        e.preventDefault();
        var target = (section && section.querySelector('[data-dl-label-modal]')) || document.querySelector('[data-dl-label-dialog]');
        if (!target) return;
        if (typeof target.showModal === 'function' && !target.open) target.showModal();
        else target.setAttribute('open', '');
      };
      openBtn.addEventListener('click', onOpen);
      if (DL && typeof DL.onDestroy === 'function') {
        DL.onDestroy(openBtn, function () { openBtn.removeEventListener('click', onOpen); delete openBtn.dataset.bound; });
      }
    }
    Array.prototype.slice.call(document.querySelectorAll('[data-dl-label-close]')).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var onClose = function () {
        var dialog = typeof btn.closest === 'function' ? btn.closest('dialog') : null;
        if (!dialog) return;
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      btn.addEventListener('click', onClose);
      if (DL && typeof DL.onDestroy === 'function') {
        DL.onDestroy(btn, function () { btn.removeEventListener('click', onClose); delete btn.dataset.bound; });
      }
    });
    Array.prototype.slice.call(document.querySelectorAll('[data-dl-label-modal], [data-dl-label-dialog]')).forEach(function (dialog) {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = '1';
      var onBackdrop = function (e) {
        if (e.target !== dialog) return;
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.addEventListener('click', onBackdrop);
      if (DL && typeof DL.onDestroy === 'function') {
        DL.onDestroy(dialog, function () { dialog.removeEventListener('click', onBackdrop); delete dialog.dataset.bound; });
      }
    });
  }

  /* Expuse pe DLProduct DOAR pentru teste (test/unit/product-cod-slot.test.mjs /
     product-label.test.mjs le rulează pe un DOM-stub, ca să verifice comportamentul, nu forma
     sursei). Nimic din temă nu le cheamă de-aici, iar expunerea nu schimbă comportamentul. */
  root.DLProduct.findEmbeddedCod = findEmbeddedCod;
  root.DLProduct.relocateEmbeddedCod = relocateEmbeddedCod;
  root.DLProduct.bindOrderButtons = bindOrderButtons;
  root.DLProduct.bindLabelDialog = bindLabelDialog;

  function bindSection(section) {
    if (section.dataset.bound) return;
    section.dataset.bound = '1';

    var teardown = [];
    function on(el, evt, handler, opts) {
      if (!el) return;
      el.addEventListener(evt, handler, opts);
      teardown.push(function () { el.removeEventListener(evt, handler, opts); });
    }
    var $ = function (sel) { return section.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(section.querySelectorAll(sel)); };

    var qtyInput = $('[data-dl-qty]');
    var atcBtn = $('[data-dl-atc]');
    var variantInput = $('[data-dl-variant-input]');

    /* ---------- Galerie ---------- */
    var mainImg = $('[data-dl-gallery-main]');
    var thumbs = $$('[data-dl-thumb]');
    var lightbox = $('[data-dl-lightbox]');
    var lightboxImg = $('[data-dl-lightbox-img]');
    var lightboxCounter = $('[data-dl-lightbox-counter]');
    var index = 0;

    function paintThumbs() {
      thumbs.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('border-primary', active);
        btn.classList.toggle('border-2', active);
        btn.classList.toggle('border-secondary-subtle', !active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (thumbs[index] && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    function goTo(i) {
      if (!thumbs.length) return;
      index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var src = thumbs[index].dataset.src;
      var srcset = thumbs[index].dataset.srcset;
      if (mainImg && src) {
        // Miniatura poartă ȘI setul de rezoluții al imaginii ei (data-srcset, aceleași lățimi ca
        // în <img>-ul din main-product.liquid). Le punem pe amândouă: dacă am seta doar `src`,
        // browserul ar rămâne cu vechiul `srcset` (imaginea greșită) — iar dacă l-am șterge, ca
        // înainte, ecranele retina ar primi de-acum o singură rezoluție în loc de 600/900/1200.
        if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
        mainImg.src = src;
      }
      paintThumbs();
      if (lightbox && lightbox.open) paintLightbox();
    }

    thumbs.forEach(function (btn, i) { on(btn, 'click', function () { goTo(i); }); });
    on($('[data-dl-gallery-prev]'), 'click', function (e) { e.preventDefault(); goTo(index - 1); });
    on($('[data-dl-gallery-next]'), 'click', function (e) { e.preventDefault(); goTo(index + 1); });

    var wrap = $('[data-dl-gallery-wrap]');
    if (wrap && thumbs.length > 1) {
      on(wrap, 'click', function () { goTo(index + 1); });
      var startX = 0, startY = 0, startedAt = 0;
      on(wrap, 'touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY; startedAt = Date.now();
      }, { passive: true });
      on(wrap, 'touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Date.now() - startedAt < 600 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) goTo(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }

    /* Tastatură: săgeți stânga/dreapta când focusul e în galerie (nu global, ca pe live). */
    var galleryCol = $('.product-gallery-col') || wrap;
    on(galleryCol, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    function paintLightbox() {
      if (!lightboxImg) return;
      var src = thumbs[index] ? thumbs[index].dataset.full : (mainImg && mainImg.currentSrc) || (mainImg && mainImg.src);
      if (src) lightboxImg.src = src;
      if (lightboxCounter) lightboxCounter.textContent = index + 1;
    }

    function openLightbox() {
      if (!lightbox) return;
      paintLightbox();
      if (typeof lightbox.showModal === 'function' && !lightbox.open) lightbox.showModal();
      else lightbox.setAttribute('open', '');
      document.body.classList.add('dl-lightbox-open');
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function' && lightbox.open) lightbox.close();
      else lightbox.removeAttribute('open');
      document.body.classList.remove('dl-lightbox-open');
    }

    on($('[data-dl-gallery-zoom]'), 'click', function (e) { e.preventDefault(); e.stopPropagation(); openLightbox(); });
    on($('[data-dl-lightbox-close]'), 'click', closeLightbox);
    on($('[data-dl-lightbox-prev]'), 'click', function () { goTo(index - 1); });
    on($('[data-dl-lightbox-next]'), 'click', function () { goTo(index + 1); });
    if (lightbox) {
      on(lightbox, 'click', function (e) { if (e.target === lightbox) closeLightbox(); });
      on(lightbox, 'close', function () { document.body.classList.remove('dl-lightbox-open'); });
      on(lightbox, 'keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });
    }

    /* ---------- Modalul etichetei (Task 37: bindLabelDialog, mai sus, e curățată prin
       DL.onDestroy pe elementele ei proprii — nu mai are nevoie de `teardown`/`on()` aici). ---------- */
    bindLabelDialog(section);

    /* ---------- Pachete de cantitate ---------- */
    var bundlesEl = $('[data-dl-bundles]');
    var rows = $$('.dl-qb-row');
    var tiers = rows.map(function (r) { return toInt(r.dataset.qbQty, 1); });
    var atcLabel = (atcBtn && (atcBtn.dataset.dlAtcLabel || atcBtn.textContent.trim())) || '';
    var unitSingular = (bundlesEl && bundlesEl.dataset.unitSingular) || '';
    var unitPlural = (bundlesEl && bundlesEl.dataset.unitPlural) || unitSingular;

    /* Prețul variantei curente, în bani — randat de Liquid pe rădăcina secțiunii și rescris de
       applyVariant() la schimbarea variantei. */
    function currentPrices() {
      /* `data-dl-no-compare` (setarea show_deal_plate = false): pagina ignoră prețul vechi. */
      return { price: toInt(section.dataset.price, 0), compare: section.hasAttribute('data-dl-no-compare') ? 0 : toInt(section.dataset.compare, 0) };
    }

    function paintRow(row, qty, totals) {
      var totalEl = row.querySelector('.dl-qb-row-total');
      var wasEl = row.querySelector('.dl-qb-row-was');
      var perUnitEl = row.querySelector('.dl-qb-row-perunit');
      var perUnitText = row.querySelector('[data-qb-perunit-text]');
      var savedEl = row.querySelector('[data-qb-saved-text]');
      var qtyTextEl = row.querySelector('[data-qb-qty-text]');
      if (qtyTextEl) qtyTextEl.textContent = qty + ' ' + (qty > 1 ? unitPlural : unitSingular);
      if (totalEl) totalEl.textContent = money(totals.total);
      /* Aceeași gardă ca în Liquid și ca în detaliul evenimentului: fără economie, nu arătăm
         preț tăiat (altfel, după o schimbare de variantă, ar apărea tăiat chiar totalul). */
      if (wasEl) { wasEl.textContent = money(totals.was); wasEl.hidden = totals.was <= totals.total; }
      if (perUnitEl) perUnitEl.textContent = money(totals.perUnit) + (unitSingular ? ' / ' + unitSingular : '');
      if (perUnitText) perUnitText.textContent = money(totals.perUnit) + (unitSingular ? ' / ' + unitSingular : '');
      if (savedEl) {
        savedEl.textContent = money(Math.max(0, totals.was - totals.total));
        var savingsEl = savedEl.closest ? savedEl.closest('.dl-qb-row-savings') : null;
        if (savingsEl) savingsEl.hidden = totals.was <= totals.total;
      }
      row.dataset.qbTotal = totals.total;
      row.dataset.qbWas = totals.was;
      row.dataset.qbPerunit = totals.perUnit;
    }

    /* Recalculează toate rândurile după prețul variantei curente (schimbare de variantă). */
    function repriceRows() {
      var p = currentPrices();
      if (!p.price) return;
      rows.forEach(function (row) {
        var qty = toInt(row.dataset.qbQty, 1);
        paintRow(row, qty, bundleTotals(p.price, p.compare, qty, toInt(row.dataset.qbDiscount, 0), toInt(row.dataset.qbAmountOff, 0)));
      });
    }

    function setActive(row, customQty) {
      if (!row) return;
      var rowQty = toInt(row.dataset.qbQty, 1);
      var qty = Math.max(1, toInt(customQty, rowQty));
      rows.forEach(function (r) {
        var active = r === row;
        r.classList.toggle('is-active', active);
        r.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      /* Toate rândurile revin la valorile treptei lor, apoi rândul activ e recalculat pentru
         cantitatea cerută (stepper liber peste ultima treaptă). */
      repriceRows();
      var p = currentPrices();
      var totals = p.price
        ? bundleTotals(p.price, p.compare, qty, toInt(row.dataset.qbDiscount, 0), qty === rowQty ? toInt(row.dataset.qbAmountOff, 0) : 0)
        : { total: toInt(row.dataset.qbTotal, 0), was: toInt(row.dataset.qbWas, 0), perUnit: toInt(row.dataset.qbPerunit, 0) };
      if (p.price && qty !== rowQty) paintRow(row, qty, totals);

      if (qtyInput && toInt(qtyInput.value, 1) !== qty) qtyInput.value = qty;
      /* Pe produs epuizat butonul păstrează „Stoc epuizat” (e și dezactivat). */
      if (atcBtn && atcLabel && !atcBtn.disabled) {
        /* Fără traducerea `atcBundle` (temă veche, DLSettings incomplet) rămâne eticheta randată
           de Liquid — mai bine decât un buton gol. */
        var bundleLabel = t('atcBundle');
        atcBtn.textContent = qty > 1 && bundleLabel ? fill(bundleLabel, { count: qty }) : atcLabel;
      }
      try {
        document.dispatchEvent(new CustomEvent('dl:bundle-changed', {
          detail: {
            qty: qty,
            total: totals.total,
            /* Contract cu bara sticky (Task 24): fără preț barat trimitem null, oglinda gărzii
               din Liquid care randează <s class="dl-qb-row-was"> doar când was > total. */
            was: totals.was > totals.total ? totals.was : null,
            perUnit: totals.perUnit,
            title: row.dataset.qbTitle || '',
            row: row,
            section: section
          }
        }));
      } catch (e) { /* CustomEvent lipsă (browsere vechi) — restul funcționează */ }
    }

    /* Cantitate tastată/steppată → treapta potrivită (exactă, altfel cea mai mare sub ea). */
    function syncFromQty(qty) {
      if (!rows.length) return;
      var exact = null;
      var below = null;
      rows.forEach(function (r) {
        var q = toInt(r.dataset.qbQty, 1);
        if (q === qty) exact = r;
        if (q <= qty && (!below || q > toInt(below.dataset.qbQty, 1))) below = r;
      });
      setActive(exact || below || rows[0], qty);
    }

    rows.forEach(function (row) {
      on(row, 'click', function () { setActive(row); });
    });

    $$('[data-dl-qty-step]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        if (!qtyInput) return;
        var next = nextAllowedQty(toInt(qtyInput.value, 1), toInt(btn.dataset.dlQtyStep, 1), tiers);
        var max = toInt(qtyInput.max, 99);
        qtyInput.value = Math.max(1, Math.min(next, max));
        syncFromQty(toInt(qtyInput.value, 1));
      });
    });

    if (qtyInput) {
      on(qtyInput, 'change', function () {
        var v = Math.max(1, Math.min(toInt(qtyInput.value, 1), toInt(qtyInput.max, 99)));
        qtyInput.value = v;
        syncFromQty(v);
      });
    }

    /* ---------- Variante ---------- */
    var variantsEl = $('[data-dl-variants]');
    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
    }
    var picker = $('[data-dl-variant-picker]');

    function selectedOptions() {
      if (!picker) return [];
      var values = [];
      picker.querySelectorAll('select[data-dl-option-index]').forEach(function (sel) {
        values[toInt(sel.dataset.dlOptionIndex, 0)] = sel.value;
      });
      picker.querySelectorAll('.variant-btn[aria-checked="true"]').forEach(function (btn) {
        values[toInt(btn.dataset.dlOptionIndex, 0)] = btn.dataset.dlOptionValue;
      });
      return values;
    }

    function applyVariant(variant) {
      if (!variant) return;
      section.dataset.variantId = variant.id;
      section.dataset.price = variant.price;
      section.dataset.compare = variant.compare_at_price || 0;
      if (variantInput) variantInput.value = variant.id;

      var nowEl = $('[data-dl-price-now]');
      var wasEl = $('[data-dl-price-was]');
      var saveEl = $('[data-dl-price-save]');
      var badge = $('[data-dl-discount-badge]');
      if (nowEl) nowEl.textContent = money(variant.price);
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      var off = hasCompare ? Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
      if (wasEl) { wasEl.textContent = money(variant.compare_at_price || 0); wasEl.hidden = !hasCompare; }
      if (saveEl) { saveEl.textContent = '-' + off + '%'; saveEl.hidden = !hasCompare; }
      if (badge) { badge.textContent = '-' + off + '%'; badge.hidden = !hasCompare; }

      var available = variant.available !== false;
      if (atcBtn) {
        atcBtn.disabled = !available;
        /* Epuizat: butonul spune „Stoc epuizat”; când redevine disponibil, setActive() de mai
           jos pune la loc eticheta potrivită cantității. */
        if (!available && atcBtn.dataset.dlAtcSoldOut) atcBtn.textContent = atcBtn.dataset.dlAtcSoldOut;
      }
      paintStock(available);
      showVariantImage(variant);

      repriceRows();
      var activeRow = section.querySelector('.dl-qb-row.is-active') || rows[0];
      if (activeRow) setActive(activeRow, qtyInput ? toInt(qtyInput.value, 1) : null);

      /* URL-ul primește ?variant=<id> ca pe orice temă Shopify — DAR nu în editorul de teme:
         acolo previzualizarea rulează într-un iframe al cărui URL e urmărit de editor, iar o
         rescriere din temă îl face să reîncarce sau să piardă secțiunea selectată. Pe magazin
         (window.Shopify.designMode e undefined) comportamentul rămâne neschimbat. */
      var inEditor = !!(window.Shopify && window.Shopify.designMode);
      if (!inEditor && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* Rândul de stoc se rescrie din atributele randate de Liquid (fără șiruri RO în JS). */
    var stockEl = $('[data-dl-stock]');
    function paintStock(available) {
      if (!stockEl) return;
      var textEl = stockEl.querySelector('[data-dl-stock-text]');
      if (textEl) {
        textEl.className = available ? 'text-success' : 'text-danger';
        textEl.textContent = (available ? stockEl.dataset.labelIn : stockEl.dataset.labelOut) || '';
        textEl.insertAdjacentHTML('afterbegin', '<i class="bi ' + (available ? 'bi-check-circle-fill' : 'bi-x-circle-fill') + ' me-1"></i>');
      }
      /* Textul „mai sunt N bucăți” e randat pentru varianta inițială: îl ascundem pe una epuizată. */
      var lowEl = stockEl.querySelector('[data-dl-lowstock]');
      if (lowEl) lowEl.hidden = !available;
    }

    /* Imaginea variantei, dacă are una: activăm miniatura corespunzătoare, altfel doar schimbăm
       imaginea mare (varianta poate avea o imagine care nu e în galerie). */
    function showVariantImage(variant) {
      var image = variant && variant.featured_image;
      if (!image) return;
      var src = image.src || image;
      if (typeof src !== 'string') return;
      var base = src.split('?')[0];
      for (var i = 0; i < thumbs.length; i++) {
        if (String(thumbs[i].dataset.src || '').split('?')[0] === base) { goTo(i); return; }
      }
      if (mainImg) { mainImg.src = src; mainImg.removeAttribute('srcset'); }
    }

    /* Combinație inexistentă în Shopify (ex. o mărime care n-a fost creată pentru culoarea aleasă):
       nu există variantă de aplicat, dar pagina NU are voie să rămână pe varianta precedentă ca și
       cum nimic nu s-ar fi întâmplat. O marcăm explicit epuizată. */
    function markSoldOut() {
      if (atcBtn) {
        atcBtn.disabled = true;
        if (atcBtn.dataset.dlAtcSoldOut) atcBtn.textContent = atcBtn.dataset.dlAtcSoldOut;
      }
      paintStock(false);
    }

    function onOptionChange() {
      var values = selectedOptions();
      if (!values.length) return;
      var picked = pickVariant(variants, values);
      if (picked.variant) applyVariant(picked.variant);
      else markSoldOut();
    }

    if (picker) {
      picker.querySelectorAll('select[data-dl-option-index]').forEach(function (sel) { on(sel, 'change', onOptionChange); });
      picker.querySelectorAll('.variant-btn').forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          var group = btn.parentElement;
          group.querySelectorAll('.variant-btn').forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('btn-primary', active);
            b.classList.toggle('active', active);
            b.classList.toggle('btn-outline-secondary', !active);
            b.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          onOptionChange();
        });
      });
    }

    /* Prețul de pornire: din varianta selectată la randare (ca să avem de unde recalcula). */
    var initialVariant = variants.filter(function (v) { return String(v.id) === String(section.dataset.variantId); })[0];
    if (initialVariant) {
      section.dataset.price = initialVariant.price;
      section.dataset.compare = initialVariant.compare_at_price || 0;
    }

    /* ---------- WhatsApp ---------- */
    $$('[data-dl-whatsapp]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        var phone = (btn.dataset.waPhone || '').replace(/[^0-9]/g, '');
        if (!phone) return;
        e.preventDefault();
        var msg = fill(t('wa'), {
          quantity: qtyInput ? Math.max(1, toInt(qtyInput.value, 1)) : 1,
          product: btn.dataset.waName || document.title,
          url: btn.dataset.waUrl || window.location.href
        });
        window.open('https://wa.me/' + phone + (msg ? '?text=' + encodeURIComponent(msg) : ''), '_blank', 'noopener');
      });
    });

    /* ---------- „Ce observă clienții” — contoare + bare ---------- */
    var feelCards = $$('[data-feel-card]');
    /* Procentele și barele sunt randate pline de Liquid (contează pentru SEO și pentru vizitatorii
       fără JS). Le aducem la 0 abia în momentul animației — cardul e sub prima vizualizare, deci
       nimeni nu apucă să vadă saltul, iar randările statice (capturi, boți) rămân corecte. */
    function animateFeel(card) {
      if (card.dataset.animated) return;
      card.dataset.animated = '1';
      var instant = reducedMotion();
      card.querySelectorAll('[data-feel-num]').forEach(function (el) {
        var target = toInt(el.dataset.feelNum, 0);
        var valEl = el.querySelector('.dl-pdp-feel-pct-val');
        if (!valEl || !target) return;
        if (instant) { valEl.textContent = target; return; }
        valEl.textContent = '0';
        var start = null;
        var frame = 0;
        var step = function (now) {
          if (start === null) start = now;
          var progress = Math.min(1, (now - start) / 1400);
          valEl.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) frame = requestAnimationFrame(step);
          else { frame = 0; valEl.textContent = target; }
        };
        frame = requestAnimationFrame(step);
        /* Bucla trebuie oprită la descărcarea secțiunii, altfel scrie într-un nod detașat. */
        teardown.push(function () { if (frame) cancelAnimationFrame(frame); });
      });
      card.querySelectorAll('[data-feel-bar]').forEach(function (bar, i) {
        var target = toInt(bar.dataset.feelBar, 0);
        if (instant) { bar.style.width = target + '%'; return; }
        bar.style.width = '0%';
        /* +30 ms peste decalajul de 90 ms/bară: lasă un cadru pentru ca tranziția pe width să pornească. */
        var timer = setTimeout(function () { bar.style.width = target + '%'; }, i * 90 + 30);
        teardown.push(function () { clearTimeout(timer); });
      });
    }
    if (feelCards.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { animateFeel(entry.target); io.unobserve(entry.target); }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -50px 0px' });
        feelCards.forEach(function (card) { io.observe(card); });
        teardown.push(function () { io.disconnect(); });
      }
      /* Plasă de siguranță (boți, browsere fără observer, carduri deja în viewport). */
      var feelTimer = setTimeout(function () { feelCards.forEach(animateFeel); }, 6000);
      teardown.push(function () { clearTimeout(feelTimer); });
    }

    /* ---------- Programul de 90 de zile — săgeți de derulare ---------- */
    $$('[data-pp-program-scroll]').forEach(function (scroller) {
      var grid = scroller.querySelector('.pp-program-grid');
      var prev = scroller.querySelector('[data-pp-scroll-prev]');
      var next = scroller.querySelector('[data-pp-scroll-next]');
      if (!grid) return;
      var step = function () {
        var card = grid.querySelector('.pp-program-card');
        if (!card) return grid.clientWidth * 0.85;
        var styles = window.getComputedStyle(grid);
        return card.offsetWidth + (parseFloat(styles.columnGap || styles.gap || '12') || 12);
      };
      var update = function () {
        var max = grid.scrollWidth - grid.clientWidth - 1;
        if (prev) prev.toggleAttribute('disabled', grid.scrollLeft <= 1);
        if (next) next.toggleAttribute('disabled', grid.scrollLeft >= max);
      };
      on(prev, 'click', function (e) { e.preventDefault(); grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
      on(next, 'click', function (e) { e.preventDefault(); grid.scrollBy({ left: step(), behavior: 'smooth' }); });
      on(grid, 'scroll', update, { passive: true });
      on(window, 'resize', update);
      update();
    });

    /* ---------- Formularul Releasit embedded → slotul de jos (Task 32/35 / A3) ---------- */
    watchEmbeddedCod(section, teardown);
    /* Task 42: bindOrderButtons() e document-wide (mai jos, propriul plugin DL.use) — butonul din
       hero e legat de-acolo, nu mai are nevoie de un apel scoped aici. */

    /* Starea inițială: rândul marcat server-side dă eticheta butonului și sincronizează bara
       sticky (Task 24), care ascultă dl:bundle-changed. */
    var initialRow = section.querySelector('.dl-qb-row.is-active') || rows[0];
    if (initialRow) setActive(initialRow);

    section._dlProductCleanup = function () {
      teardown.forEach(function (fn) { fn(); });
      teardown.length = 0;
      /* Dacă secțiunea dispare cu lightbox-ul deschis, <body> ar rămâne blocat pe overflow. */
      closeLightbox();
      section._dlProductCleanup = null;
      delete section.dataset.bound;
    };
  }

  function initProduct(scope) {
    var node = scope || document;
    if (node.matches && node.matches('[data-dl-product]')) bindSection(node);
    if (node.querySelectorAll) node.querySelectorAll('[data-dl-product]').forEach(bindSection);
  }

  function cleanup(node) {
    if (!node) return;
    if (node.matches && node.matches('[data-dl-product]') && typeof node._dlProductCleanup === 'function') node._dlProductCleanup();
    if (node.querySelectorAll) {
      node.querySelectorAll('[data-dl-product]').forEach(function (section) {
        if (typeof section._dlProductCleanup === 'function') section._dlProductCleanup();
      });
    }
  }

  /* Scriptul secțiunii poate fi inclus de mai multe ori pe pagină (două secțiuni main-product
     în editor): ascultătorul global se pune o singură dată. */
  if (!DL._dlProductUnloadBound) {
    DL._dlProductUnloadBound = true;
    document.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); });
  }

  /* theme.js e încărcat tot cu defer, la finalul body-ului: DL.use există abia la DOMContentLoaded.
     Legăm direct pentru pagina curentă și ne înregistrăm ca plugin pentru re-randările din
     editorul de teme (shopify:section:load → DL.init). bindSection e idempotent. */
  document.addEventListener('DOMContentLoaded', function () {
    initProduct(document);
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(initProduct);
  });

  /* Task 42: butoanele „Comandă acum" repetate trăiesc în alte secțiuni decât [data-dl-product]
     (product-video-duo, product-benefits-image, product-transformation,
     product-video-testimonials) — de-asta legarea e un plugin DL.use PROPRIU, document-wide, nu
     doar un apel din bindSection. `readyState === 'complete'` prinde cazul rar în care scriptul
     ăsta e injectat DUPĂ ce pagina a pornit deja (editorul de teme) — vezi aceeași gardă în
     theme/assets/section-footer-delfino.js / section-product-video-testimonials.js. */
  /* ===== Oferta aleasă în pagină → oferta din formularul Releasit (23.09.2026) =====
     Clientul alege cantitatea în erou (treptele dl-qb-row) sau pe cardurile „Câte îți trebuie"
     (product-piece-count, [data-ppc-qty]); când formularul Releasit există / apare (embedded sau
     popup după click pe „Comandă acum"), bifăm în el oferta cu ACEEAȘI cantitate. Invers, dacă
     omul alege oferta direct în formular, treapta din erou se mută pe aceeași cantitate.
     Cantitatea unei oferte Releasit: din config-ul aplicației (window._RSI_COD_FORM_QUANTIY_OFFERS,
     grupurile active ale produsului, după `pos`), altfel din primul număr din titlu, altfel 1.
     Nu completează și nu trimite nimic în formular — doar dă click pe cardul ofertei. */
  var RSI_OFFER_SEL = '[id="rsi-cod-form-quantity-offers-hook"] ._rsi-quantity-offers-offer-container';
  var RSI_TRIGGER_SEL = '._rsi-buy-now-button, [class*="_rsi-buy-now"], [data-dl-rsi-hook], [data-dl-order-btn], [data-dl-hero-order], [data-ppc-qty]';

  function rsiQtyByPos() {
    var map = {};
    try {
      var cacheEl = document.querySelector('script#rsi-cod-form-product-cache');
      var pid = cacheEl ? String((JSON.parse(cacheEl.textContent) || {}).id || '') : '';
      var groups = (root._RSI_COD_FORM_QUANTIY_OFFERS || []).filter(function (g) {
        return g && Array.isArray(g.pIds) && (!pid || g.pIds.map(String).indexOf(pid) !== -1);
      });
      var active = groups.filter(function (g) { return g.isActive === true; });
      (active.length ? active : groups).forEach(function (g) {
        (g.offers || []).forEach(function (o) {
          if (o && typeof o.pos === 'number' && typeof o.qty === 'number') map[o.pos] = o.qty;
        });
      });
    } catch (e) { /* config lipsă sau stricat — cădem pe titlu */ }
    return map;
  }

  function rsiOfferQty(el, map) {
    var pos = el.getAttribute('data-offer-pos');
    if (pos !== null && map[toInt(pos, -1)]) return map[toInt(pos, -1)];
    var titleEl = el.querySelector('._rsi-quantity-offers-title');
    var m = ((titleEl ? titleEl.textContent : el.textContent) || '').match(/(\d+)/);
    return m ? toInt(m[1], 1) : 1;
  }

  function bindOfferSync() {
    if (root._dlOfferSyncBound || !document.querySelector('[data-dl-bundles], [data-ppc-qty]')) return;
    root._dlOfferSyncBound = true;
    var wantedQty = 0;
    var userChose = false;
    var quietUntil = 0;
    var pollTimer = null;

    function heroRow(qty) {
      return document.querySelector('[data-dl-bundles] .dl-qb-row[data-qb-qty="' + qty + '"]');
    }
    function currentQty() {
      var row = document.querySelector('[data-dl-bundles] .dl-qb-row.is-active');
      return row ? toInt(row.dataset.qbQty, 1) : 1;
    }

    /* Bifează în TOATE formularele Releasit (embedded + popup) oferta cu cantitatea dorită.
       Întoarce true dacă a găsit măcar un formular cu oferte. */
    function applyToRsi(qty) {
      var offers = document.querySelectorAll(RSI_OFFER_SEL);
      if (!offers.length) return false;
      var map = rsiQtyByPos();
      var hooks = [];
      for (var i = 0; i < offers.length; i++) {
        var hook = offers[i].closest('[id="rsi-cod-form-quantity-offers-hook"]');
        if (hooks.indexOf(hook) === -1) hooks.push(hook);
      }
      hooks.forEach(function (hook) {
        var list = hook.querySelectorAll('._rsi-quantity-offers-offer-container');
        for (var j = 0; j < list.length; j++) {
          if (rsiOfferQty(list[j], map) === qty) {
            if (!list[j].classList.contains('_rsi-quantity-offers-selected')) {
              quietUntil = Date.now() + 500;
              list[j].click();
            }
            return;
          }
        }
      });
      return true;
    }

    /* Formularul apare asincron (la încărcare sau după click pe butonul Releasit): încercăm
       câteva secunde, apoi ne oprim. */
    function applySoon(ms) {
      clearInterval(pollTimer);
      var until = Date.now() + (ms || 4000);
      var qty = wantedQty || currentQty();
      if (applyToRsi(qty) && !ms) return;
      pollTimer = setInterval(function () {
        applyToRsi(wantedQty || currentQty());
        if (Date.now() > until) clearInterval(pollTimer);
      }, 250);
    }

    /* Cardurile „Câte îți trebuie": prețul real al treptei cu aceeași cantitate + selectare. */
    function paintCards() {
      var active = currentQty();
      var cards = document.querySelectorAll('[data-ppc-qty]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var q = toInt(card.getAttribute('data-ppc-qty'), 0);
        var row = heroRow(q);
        var priceEl = card.querySelector('[data-ppc-price]');
        if (!row) continue;
        if (!card.hasAttribute('role')) { card.setAttribute('role', 'button'); card.setAttribute('tabindex', '0'); }
        card.classList.add('is-selectable');
        card.classList.toggle('is-active', q === active);
        card.setAttribute('aria-pressed', q === active ? 'true' : 'false');
        if (priceEl) {
          var totalEl = row.querySelector('.dl-qb-row-total');
          var wasEl = row.querySelector('.dl-qb-row-was');
          var t = priceEl.querySelector('[data-ppc-total]');
          var w = priceEl.querySelector('[data-ppc-was]');
          if (t && totalEl) t.textContent = totalEl.textContent;
          if (w) { w.textContent = wasEl && !wasEl.hidden ? wasEl.textContent : ''; w.hidden = !w.textContent; }
          priceEl.hidden = !(t && t.textContent);
        }
      }
    }

    function pickQty(qty) {
      var row = heroRow(qty);
      if (row && !row.classList.contains('is-active')) row.click();
      else { wantedQty = qty; paintCards(); applySoon(1500); }
    }

    document.addEventListener('dl:bundle-changed', function (e) {
      wantedQty = e && e.detail ? toInt(e.detail.qty, 1) : currentQty();
      userChose = true;
      paintCards();
      if (Date.now() > quietUntil) applySoon(1500);
    });

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var offer = t.closest(RSI_OFFER_SEL.split(' ').pop());
      if (offer && offer.closest('[id="rsi-cod-form-quantity-offers-hook"]')) {
        /* Alegere făcută direct în formular → treapta din erou (fără să ricoșeze înapoi). */
        if (Date.now() < quietUntil || !e.isTrusted) return;
        var q = rsiOfferQty(offer, rsiQtyByPos());
        wantedQty = q;
        userChose = true;
        quietUntil = Date.now() + 500;
        var row = heroRow(q);
        if (row && !row.classList.contains('is-active')) row.click();
        return;
      }
      var card = t.closest('[data-ppc-qty].is-selectable');
      if (card && !t.closest('a, button')) { pickQty(toInt(card.getAttribute('data-ppc-qty'), 1)); return; }
      if (t.closest(RSI_TRIGGER_SEL)) applySoon(4000);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target && e.target.closest ? e.target.closest('[data-ppc-qty].is-selectable') : null;
      if (card && e.target === card) { e.preventDefault(); pickQty(toInt(card.getAttribute('data-ppc-qty'), 1)); }
    });

    paintCards();
    applySoon(12000);

    /* Plasa de siguranță (24.09.2026, raportat pe Ulei: 6 bucăți în erou, 1 bucată în formular):
       pe telefon, Releasit își poate re-randa formularul MAI TÂRZIU (relocare, popup, reîncărcare
       lentă) și revine la oferta implicită. Cât timp omul a ales o cantitate (erou, carduri sau direct
       în formular), verificăm la fiecare secundă că formularul are aceeași ofertă bifată și o bifăm la
       loc dacă nu. Nu dăm click decât când diferă, deci nu atingem formularul degeaba. */
    setInterval(function () {
      if (userChose && !document.hidden) applyToRsi(wantedQty || currentQty());
    }, 1000);
  }
  root.DLProduct.rsiOfferQty = rsiOfferQty;
  /* 29.09: și harta pos → cantitate, pentru scan-handoff.js (trimiterea din Scanarea Unghii AI). */
  root.DLProduct.rsiQtyByPos = rsiQtyByPos;

  function registerOrderButtons() {
    bindOrderButtons(document);
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(bindOrderButtons);
    bindOfferSync();
  }
  document.readyState === 'complete' ? registerOrderButtons() : document.addEventListener('DOMContentLoaded', registerOrderButtons);
})(typeof globalThis !== 'undefined' ? globalThis : this);
